import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import PlaceholderPage from "../components/feature/PlaceholderPage";
import HomePage from "../pages/home/page";
import SignInPage from "../pages/auth/SignInPage";
import SignUpPage from "../pages/auth/SignUpPage";
import AdminCustomersPage from "../pages/admin/AdminCustomersPage";
import AdminCustomerDetailPage from "../pages/admin/AdminCustomerDetailPage";
import ContentSectionPage from "../pages/admin/ContentSectionPage";
import AdminLayout from "../pages/admin/components/AdminLayout";
import QuotationTemplatePage from "../pages/admin/quotation-template/page";
import DashboardPage from "../pages/my/DashboardPage";
import CompanyPage from "../pages/my/CompanyPage";
import ProductsPage from "../pages/products/page";
import ProductDetailPage from "../pages/products/detail/page";
import DashboardLayout from "../pages/my/components/DashboardLayout";
import OrdersPage from "../pages/my/OrdersPage";
import QuotesPage from "../pages/my/QuotesPage";
import QuoteDetailPage from "../pages/my/QuoteDetailPage";
import FinalOfferPage from "../pages/my/FinalOfferPage";
import PaymentsPage from "../pages/my/PaymentsPage";
import ShippingPage from "../pages/my/ShippingPage";
import MessagesPage from "../pages/my/MessagesPage";
import SamplesPage from "../pages/my/SamplesPage";
import FilesPage from "../pages/my/FilesPage";
import FavoritesPage from "../pages/my/FavoritesPage";
import AiPreviewsPage from "../pages/my/AiPreviewsPage";
import MarketPage from "../pages/my/MarketPage";
import FinishingPreviewPage from "../pages/products/detail/FinishingPreviewPage";
import QuotePage from "../pages/quote/page";
import CustomizeQuotePage from "../pages/customize-quote/page";
import QuotationDesignPage from "../pages/quotation-design/page";
import CartPage from "../pages/cart/page";
import ImageSearchPage from "../pages/image-search/page";
import SupplierNetworkPage from "../pages/supplier-network/page";
import HowItWorksPage from "../pages/how-it-works/page";
import AboutPage from "../pages/about/page";
import ImageViewerPage from "../pages/image-viewer/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/image-search",
    element: <ImageSearchPage />,
  },
  {
    path: "/packaging",
    element: <ProductsPage />,
  },
  {
    path: "/packaging/:id",
    element: <ProductDetailPage />,
  },
  {
    path: "/packaging/:id/finishing-preview",
    element: <FinishingPreviewPage />,
  },
  {
    path: "/packaging/:id/customize",
    element: <CustomizeQuotePage />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/products/:id",
    element: <ProductDetailPage />,
  },
  {
    path: "/products/:id/finishing-preview",
    element: <FinishingPreviewPage />,
  },
  {
    path: "/products/:id/customize",
    element: <CustomizeQuotePage />,
  },
  {
    path: "/how-it-works",
    element: <HowItWorksPage />,
  },
  {
    path: "/supplier-network",
    element: <SupplierNetworkPage />,
  },
  {
    path: "/quality-control",
    element: <PlaceholderPage titleKey="nav.qualityControl" />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/quote",
    element: <Navigate to="/get-quote" replace />,
  },
  {
    path: "/get-quote",
    element: <QuotePage />,
  },
  {
    path: "/quotation-design",
    element: <QuotationDesignPage />,
  },
  {
    path: "/cart",
    element: <CartPage />,
  },
  {
    path: "/sign-in",
    element: <SignInPage />,
  },
  {
    path: "/sign-up",
    element: <SignUpPage />,
  },
  // B2B customer area
  {
    path: "/my",
    element: <DashboardLayout />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "quotes", element: <QuotesPage /> },
      { path: "quotes/:id", element: <QuoteDetailPage /> },
      { path: "final-offers/:id", element: <FinalOfferPage /> },
      { path: "orders", element: <OrdersPage /> },
      { path: "payments", element: <PaymentsPage /> },
      { path: "shipping", element: <ShippingPage /> },
      { path: "finish-previews", element: <AiPreviewsPage /> },
      { path: "favorites", element: <FavoritesPage /> },
      { path: "messages", element: <MessagesPage /> },
      { path: "samples", element: <SamplesPage /> },
      { path: "files", element: <FilesPage /> },
      { path: "company", element: <CompanyPage /> },
      { path: "market", element: <MarketPage /> },
      { path: "addresses", element: <PlaceholderPage title="Addresses" /> },
      { path: "settings", element: <PlaceholderPage title="Account Settings" /> },
    ],
  },
  // Admin area
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: <Navigate to="/admin/notice" replace /> },
      { path: "notice", element: <ContentSectionPage section="notice" /> },
      { path: "company", element: <ContentSectionPage section="company" /> },
      { path: "hero", element: <ContentSectionPage section="hero" /> },
      { path: "cta", element: <ContentSectionPage section="cta" /> },
      { path: "finishing", element: <ContentSectionPage section="finishing" /> },
      { path: "category", element: <ContentSectionPage section="category" /> },
      { path: "customers", element: <AdminCustomersPage /> },
      { path: "customers/:id", element: <AdminCustomerDetailPage /> },
      { path: "quotation-template", element: <QuotationTemplatePage /> },
    ],
  },
  {
    path: "/image-viewer",
    element: <ImageViewerPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;